import React from 'react'
import { DEMO } from 'Constants'
import Icon, { TopBarLogo } from '../Icons'
import AppContext from 'AppContext'
import { adminEmail } from 'components/Helpers'

// admin-auth-consolidation Phase 2 (S3.5): the operator dropdown is gone. It was
// cosmetic — `change_operator` only alerted "sign out and in again to switch" —
// and switching operators is not supported. The admin's operator comes from the
// JWT and is resolved to its reference (name) in scenes/Main.js, so this just
// displays the current operator rather than offering a list to pick from.
const OperatorSelector = () => {
  const selectedOperator = React.useContext(AppContext).operator

  if (!selectedOperator || !selectedOperator.id) {
    return (<div className='operator'>No operators found</div>)
  }

  return (
    <div className='operator'>
      {selectedOperator.name || selectedOperator.id}
    </div>
  )
}

const UserBox = () => {
  const { currentAdmin } = React.useContext(AppContext)

  return (
    <div
      className='user-box'
    >
      {adminEmail(currentAdmin)}
    </div>
  )
}

const ErrorNote = ({ error }) => {
  if (!error) return null

  return (
    <div className='demo'>
      <Icon type='error' color='white' />
      &nbsp;&nbsp;We are experiencing some issues with the system
    </div>
  )
}

const DemoNote = () => (
  <div className='demo'>
    {DEMO ? 'NOTE: in demo mode with some static dummy data' : ''}
  </div>
)

const Header = (props) => (
  <header>
    <nav className='top-bar desktop'>
      <TopBarLogo className='logo' />
      <OperatorSelector />
      <DemoNote />
      <ErrorNote error={props.error} />
      <UserBox />
    </nav>
    <nav className='top-bar mobile'>
      <div className='mobile-nav' onClick={props.methods.toggle_mobile_nav}>
        <Icon type='bars' color='white' height='25px' width='25px' />
      </div>
    </nav>
  </header>
)

export default Header

export {
  OperatorSelector
}
